import { z } from 'zod';

// Bank details schema
const bankDetailsSchema = z.object({
  account_name: z.string().min(1, 'Account name is required'),
  account_number: z.string().min(1, 'Account number is required'),
  bank_name: z.string().min(1, 'Bank name is required'),
  branch: z.string().min(1, 'Branch is required'),
  ifsc_code: z.string().min(1, 'IFSC code is required')
}).optional();

// Address schema
const addressSchema = z.object({
  type: z.enum(['billing', 'shipping']),
  address_line1: z.string().min(1, 'Address line 1 is required'),
  address_line2: z.string().optional(),
  city: z.string().min(1, 'City is required'),
  state: z.string().min(1, 'State is required'),
  pincode: z.string().regex(/^\d{6}$/, 'Invalid pincode format'),
  country: z.string().min(1, 'Country is required'),
  is_primary: z.boolean().default(true)
});

export const supplierSchema = z.object({
  name: z.string().min(2, 'Supplier name must be at least 2 characters'),
  type: z.enum(['individual', 'company', 'transporter']),
  contact_person: z.string().min(2, 'Contact person name must be at least 2 characters'),
  phone: z.string().regex(/^[+]?[0-9\s-()]{10,}$/, 'Invalid phone number format'),
  email: z.string().email('Invalid email format').optional().or(z.literal('')),
  gstin: z.string()
    .regex(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/, 'Invalid GSTIN format')
    .optional()
    .or(z.literal('')),
  pan: z.string()
    .regex(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN format')
    .optional()
    .or(z.literal('')),
  payment_terms: z.string().optional(),
  credit_limit: z.number().min(0, 'Credit limit must be 0 or greater').optional(),
  addresses: z.array(addressSchema).min(2, 'Both billing and shipping addresses are required'),
  bank_details: bankDetailsSchema
});

export type SupplierFormData = z.infer<typeof supplierSchema>;